import Seo from "@/components/Seo";
import LeadForm from "@/components/LeadForm";
import { FadeUp, MaskedLines } from "@/components/Reveal";
import { Eyebrow } from "@/components/shared";
import { Phone, Mail, MapPin } from "lucide-react";

const Contact = () => (
  <>
    <Seo
      title="Contact | Scherif Real Estate — Soby & Associates"
      siteName="Scherif Real Estate"
      description="Let's start a conversation. Call 240-372-4804 or email Sobeida@realestatebyscherif.com — luxury real estate across DC, Maryland, and Virginia."
    />

    <section className="container-luxe pb-24 pt-36 sm:pt-48" data-testid="contact-page">
      <FadeUp>
        <Eyebrow className="mb-6">Contact</Eyebrow>
        <h1 className="max-w-3xl font-serif text-5xl font-light leading-[1.08] tracking-tight text-charcoal sm:text-7xl" data-testid="contact-headline">
          <MaskedLines delay={0.2} lines={["Let's Start", "a Conversation."]} />
        </h1>
      </FadeUp>

      <div className="mt-20 grid gap-16 lg:grid-cols-12">
        <FadeUp delay={0.1} className="lg:col-span-4">
          <div className="space-y-10">
            <div>
              <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Call</p>
              <a href="tel:+12403724804" data-testid="contact-phone" className="flex items-center gap-3 font-serif text-3xl font-light text-charcoal transition-colors hover:text-champagne">
                <Phone size={20} strokeWidth={1.25} aria-hidden="true" /> 240-372-4804
              </a>
            </div>
            <div>
              <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Email</p>
              <a href="mailto:Sobeida@realestatebyscherif.com" data-testid="contact-email" className="flex items-center gap-3 break-all text-base text-charcoal transition-colors hover:text-champagne">
                <Mail size={16} strokeWidth={1.25} aria-hidden="true" /> Sobeida@realestatebyscherif.com
              </a>
            </div>
            <div>
              <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Serving</p>
              <p className="flex items-center gap-3 text-base text-charcoal">
                <MapPin size={16} strokeWidth={1.25} aria-hidden="true" /> DC, Maryland, and Virginia
              </p>
            </div>
          </div>
        </FadeUp>

        <FadeUp delay={0.2} className="lg:col-span-8">
          <div className="border border-warm-border bg-white p-6 shadow-[0_20px_60px_rgba(0,0,0,0.05)] sm:p-10">
            <LeadForm type="contact" testIdPrefix="contact" />
          </div>
        </FadeUp>
      </div>
    </section>
  </>
);

export default Contact;
